import React from "react";
import { useOutletContext } from "react-router-dom";
import SingleBannerTree from "../../../components/SingleBannerTree";
import SiteHomePageData from "../SiteHomePageData";
import { saffronURL } from "../../../Url";


const ConnectHome = () => {
    const {
    selectedCountry,
    selectedCategory,
    selectedLanguage,
    selectedState,
    selectedCity,
  } = useOutletContext();
  return (
    <>
      <div className="bg-gradient-to-b from-[#fff0e4] to-[#fff0e4]">
        {selectedCity ? (
          <SingleBannerTree
            selectedCategory={selectedCategory}
            selectedCountry={selectedCountry}
            selectedLanguage={selectedLanguage}
            selectedState={selectedState}
            selectedCity={selectedCity}
            api={saffronURL}
          />
        ) : (
          <>
            
            <SiteHomePageData
              selectedCategory={selectedCategory}
              selectedCountry={selectedCountry}
              selectedLanguage={selectedLanguage}
              selectedState={selectedState}
              selectedCity={selectedCity}
              api={saffronURL}
            />
          </>
        )}
      </div>
    </>
  );
};

export default ConnectHome;
